import API from "../../../../../global/api";
import jsPDF from "jspdf";
import moment from "moment";
import { isEmpty } from "lodash";
import { PDFHeader } from "../../../../../global/globalFunctions";


export const requestAddExpense = () => {
    return {
        type: "REQUEST_ADD_EXPENSE",
    };
};
export const successAddExpense = (data) => {
    return {
        type: "SUCCESS_ADD_EXPENSE",
        payload: data,
    };
};
export const errorAddExpense = () => {
    return {
        type: "ERROR_ADD_EXPENSE",
    };
};
export const AddExpenseApi = (payload, showSuccessAlert, showErrorAlert) => {
    return (dispatch) => {
        dispatch(requestAddExpense());
        API.post(`/construction/update-order-expense`, payload)
            .then((res) => {
                dispatch(successAddExpense(payload));
                showSuccessAlert(res.data.message);
            }).catch((error) => {
                dispatch(errorAddExpense());
                showErrorAlert(error.response.data.message || "Something went wrong");
            });
    };
};


export const requestGetExpenseByOrderCategory = () => {
    return {
        type: "REQUEST_GET_EXPENSE_BY_ORDER_CATEGORY",
    };
};
export const successGetExpenseByOrderCategory = (response) => {
    return {
        type: "SUCCESS_GET_EXPENSE_BY_ORDER_CATEGORY",
        payload: response,
    };
};
export const errorGetExpenseByOrderCategory = () => {
    return {
        type: "ERROR_GET_EXPENSE_BY_ORDER_CATEGORY",
    };
};
export const GetExpenseByOrderCategoryApi = (orderId, categoryId) => {
    return (dispatch) => {
        dispatch(requestGetExpenseByOrderCategory());
        API.post(`/construction/get-order-expense-with-category`, { orderId, categoryId })
            .then((res) => {
                let response = res.data;
                dispatch(successGetExpenseByOrderCategory(response));
            }).catch((error) => {
                dispatch(errorGetExpenseByOrderCategory());
            });
    };
};


export const requestGetExpenseReport = () => {
    return {
        type: "REQUEST_GET_EXPENSE_REPORT",
    };
};
export const successGetExpenseReport = (response) => {
    return {
        type: "SUCCESS_GET_EXPENSE_REPORT",
        payload: response,
    };
};
export const errorGetExpenseReport = () => {
    return {
        type: "ERROR_GET_EXPENSE_REPORT",
    };
};
export const GetExpenseReport = (data, startDate, endDate) => {
    return async (dispatch) => {
        dispatch(requestGetExpenseReport());
        try {
            const response = await API.post(`/construction/expense-report`, data);
            const responseResult = response.data.data;
            dispatch(successGetExpenseReport(response.data));
            if (data.type === "excel") {
                import("xlsx").then((XLSX) => {
                    const headers = [
                        "S.No",
                        "Date",
                        "Invoice Number",
                        "Supplier Name",
                        "VATIN Number",
                        "Amount",
                        "VAT %",
                        "Total Amount",
                        "Description",
                    ];

                    const rows = responseResult?.extraServiceExpenseData.map((x, i) => [
                        i + 1,
                        moment(x.date).format("DD-MM-YYYY"),
                        x.invoiceNo,
                        x.supplierName,
                        x.vatinNo,
                        x.amount,
                        x.vat,
                        x.total,
                        x.description,
                    ]);

                    // Add report title and date range above headers
                    const sheetData = [
                        // ["Expense Report"],
                        // [`Start Date: ${startDate}`, "", `End Date: ${endDate}`],
                        // [], // blank row
                        headers,
                        ...rows,
                    ];

                    const ws = XLSX.utils.aoa_to_sheet(sheetData);

                    // Column widths
                    ws["!cols"] = [
                        { wch: 6 },   // S.No
                        { wch: 14 },  // Date
                        { wch: 18 },  // Invoice Number
                        { wch: 22 },  // Supplier Name
                        { wch: 18 },  // VATIN Number
                        { wch: 12 },  // Amount
                        { wch: 8 },   // VAT %
                        { wch: 14 },  // Total Amount
                        { wch: 30 },  // Description
                    ];

                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Expense Report");
                    XLSX.writeFile(wb, `Expense_Report_${moment().format("YYYY-MM-DD")}.xlsx`);
                });
            } else if (data.type === "pdf") {
                const unit = "pt";
                const size = "A4";
                const orientation = "l";
                const doc = new jsPDF(orientation, unit, size);
                PDFHeader(doc, "VAT Report for the Period");

                doc.setFont("TimesNewRoman", "Normal");
                doc.setFontSize(11);
                doc.text(`Start Date: ${startDate}`, 50, 135, 0, 20);
                doc.text(`End Date: ${endDate}`, 50, 150, 0, 20);

                const headers = [[
                    "S.No",
                    "Date",
                    "Invoice Number",
                    "Supplier Name",
                    "VATIN Number",
                    "Amount",
                    "VAT %",
                    "Total Amount",
                    "Description",
                ]];
                const data = responseResult?.extraServiceExpenseData.map((x, i) => [
                    i + 1,
                    moment(x.date).format("DD-MM-YYYY"),
                    x.invoiceNo,
                    x.supplierName,
                    x.vatinNo,
                    x.amount,
                    x.vat,
                    x.total,
                    x.description,
                ]);
                let content = {
                    margin: {
                        left: 12,
                        right: 35,
                    },
                    startY: 175,
                    styles: {
                        fontSize: 9,
                        lineColor: [0, 0, 0],
                        lineWidth: 0.2,
                    },
                    head: headers,
                    body: data,
                    theme: 'grid',
                };
                doc.autoTable(content);


                doc.setProperties(`Expense Report ${moment().format("YYYY-MM-DD")}`);
                var blob = doc.output("blob");
                window.open(URL.createObjectURL(blob));
            } else {
                console.error("Unsupported report type");
                alert("Unsupported report type");
            }
        } catch (error) {
            console.log(error);
            dispatch(errorGetExpenseReport());
        }
    };
};